/**
 * Converts a snake case string to title case.
 * Example: SNAKE_CASE => Snake Case
 *
 * @param  {String} value the string to convert
 * @return {String}
 */
export default function(value) {
  if (!value || typeof value !== 'string') return '';
  return value.toLowerCase().split('_').map(function(item) {
    return item.charAt(0).toUpperCase() + item.substring(1);
  }).join(' ');
}
